import Matter from "matter-js";

export interface PhysicsWorld {
  engine: Matter.Engine;
  world: Matter.World;
  step: (deltaMs: number) => void;
}

export function createPhysics(): PhysicsWorld {
  const engine = Matter.Engine.create({
    gravity: { x: 0, y: 1, scale: 0.001 },
  });
  return {
    engine,
    world: engine.world,
    step: (deltaMs) => Matter.Engine.update(engine, Math.min(deltaMs, 32)),
  };
}

export function addStaticWalls(
  world: Matter.World,
  width: number,
  height: number,
  wallThickness = 60,
): void {
  const opts: Matter.IBodyDefinition = {
    isStatic: true,
    friction: 0.2,
    restitution: 0.1,
    label: "wall",
  };
  Matter.World.add(world, [
    Matter.Bodies.rectangle(width / 2, -wallThickness / 2, width, wallThickness, opts),
    // No bottom wall: particles must fall off-screen and be invalidated by the ticker cleanup.
    Matter.Bodies.rectangle(-wallThickness / 2, height / 2, wallThickness, height * 2, opts),
    Matter.Bodies.rectangle(width + wallThickness / 2, height / 2, wallThickness, height * 2, opts),
  ]);
}
